import { Component, OnDestroy, ViewChild } from '@angular/core';
import { BaseRoutes, CartRoutes } from '@core/constants/routes.const';
import { LocalStorageKey } from '@core/enums/local-storage-key.enum';
import { ModalConfig } from '@core/models/modal-config.model';
import { LocalStorageService } from '@core/services/local-storage.service';
import { AppState } from '@core/store';
import { setMultiplePurchaseLimitModalOpen } from '@core/store/cart/cart.actions';
import { Store } from '@ngrx/store';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cart-item-updated-warning-modal',
  templateUrl: './cart-item-updated-warning-modal.component.html',
  styleUrls: ['./cart-item-updated-warning-modal.component.scss'],
})
export class CartItemUpdatedWarningModalComponent implements OnDestroy {
  readonly Routes = {
    CustomerSpecialOffers: BaseRoutes.CustomerSpecialOffers,
    ShoppingCart: CartRoutes.ShoppingCart,
  };

  modalConfig: ModalConfig = {
    ngbModalOptions: { size: 'md' },
    title: $localize`Expired Special(s) Removed`,
    hideCloseButton: true,
    hideDismissButton: true,
    onDismiss: this.close.bind(this),
    onDismissHeader: this.close.bind(this),
  };

  @ViewChild('modal') private modal: ModalComponent;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private localStorageService: LocalStorageService,
    private store$: Store<AppState>,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  open(): void {
    this.modal.open();
  }

  close(): void {
    this.store$.dispatch(setMultiplePurchaseLimitModalOpen({ shouldOpenModal: true }));
    this.localStorageService.removeItem(LocalStorageKey.isCartUpdated);
    this.modal.close();
  }
}
